export default {
  SEARCH_BOX_PLACEHOLDER: 'Type to search...',
};
